module.exports = __webpack_public_path__ + "img/king-on-africa.2580fec4.jpg";